import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import { loginFields } from "../../constants/formFields";
import Input from "./Input";
import FormExtra from "./FormExtra";
import FormAction from "./FormAction";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";

const fields = loginFields;
const fieldsState = {};
fields.forEach((field) => (fieldsState[field.id] = ""));

const Login = ({ onLoginSuccess }) => {
  const navigate = useNavigate();
  const [loginState, setLoginState] = useState(fieldsState);
  const [loginError, setLoginError] = useState(null);

  const handleChange = (e) => {
    setLoginState({ ...loginState, [e.target.id]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    authenticateUser();
  };

  const authenticateUser = () => {
    const { mobile, password, role } = loginState;

    const user = {
      mobile,
      password,
      role: "user",
    };

    axios
      .post("https://backend.grahaksathi.in/api/user/signin", user)
      .then((response) => {
        console.log(response.data);
        const token = response.data.token;
        const firstName = response.data.user.firstName;
        localStorage.setItem("token", token);
        localStorage.setItem("role", role);
        localStorage.setItem("username", firstName);
        Swal.fire({
          icon: "success",
          title: "Login Successful!",
          text: "Click Ok to continue",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = "/userDash/home";
          }
        });
        onLoginSuccess(role);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Error occurred.Incorrect Mobile or password");
      });
  };

  return (
    <>
      <form className="mt-12 space-y-6" onSubmit={handleSubmit}>
        <div className="-space-y-px">
          {fields.map((field) => (
            <Input
              key={field.id}
              handleChange={handleChange}
              value={loginState[field.id]}
              role={loginState[field.role]}
              labelText={field.labelText}
              labelFor={field.labelFor}
              id={field.id}
              name={field.name}
              type={field.type}
              isRequired={field.isRequired}
              placeholder={field.placeholder}
            />
          ))}
        </div>

        <FormExtra />
        <FormAction handleSubmit={handleSubmit} text="Login" />
        {loginError && <p>{loginError}</p>}
      </form>
      <ToastContainer />
    </>
  );
};

export default Login;
